import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

export const queryCompetior = data => {
    return api.post(`${baseApi}/customerCompetitor/getCustomerCompetitorPage`, data);
};

export const addCompetior = data => {
    return api.post(`${baseApi}/customerCompetitor/addCustomerCompetitor`, data);
};

export const updateCompetior = data => {
    return api.post(`${baseApi}/customerCompetitor/updateCustomerCompetitor`, data);
};

export const deleteCompetior = ({ competitorId }) => {
    return api.post(`${baseApi}/customerCompetitor/removeCustomerCompetitor/${competitorId}`);
};
